import { render, staticRenderFns } from "./LeftSteps.vue?vue&type=template&id=6d51a1e8&scoped=true"
import script from "./LeftSteps.vue?vue&type=script&lang=js"
export * from "./LeftSteps.vue?vue&type=script&lang=js"
import style0 from "./LeftSteps.vue?vue&type=style&index=0&id=6d51a1e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51a1e8",
  null
  
)

export default component.exports